<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Configure Maintenance Meal Plan</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content color="light">
  <div *ngIf="isLoading" class="loading-container">
    <ion-spinner name="bubbles" color="primary"></ion-spinner>
  </div>

  <div *ngIf="!isLoading && form">
    <p class="config-subtitle">
      Drag to reorder. Toggle to include or exclude from the meal plan.
    </p>

    <form [formGroup]="form">
      <div class="config-section">
        <ion-grid>
          <ion-row>
            <ion-col>
              <ion-item>
                <ion-label position="stacked" color="primary">Name</ion-label>
                <ion-input type="text" formControlName="plan_name"></ion-input>
              </ion-item>
              <small class="text-danger ion-padding-start" *ngIf="form.get('plan_name')?.invalid && form.get('plan_name')?.touched">
                Name is required.
              </small>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-item>
                <ion-label position="stacked" color="primary">Plan Type</ion-label>
                <ion-select formControlName="plan_type">
                  <ion-select-option value="full_maintenance">Full Maintenance</ion-select-option>
                  <ion-select-option value="limited_maintenance">Limited Maintenance</ion-select-option>
                </ion-select>
              </ion-item>
              <small class="text-danger ion-padding-start" *ngIf="form.get('plan_type')?.invalid && form.get('plan_type')?.touched">
                Plan type is required.
              </small>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-item>
                <ion-label position="stacked" color="primary">Carb Range</ion-label>
                <ion-input type="text" inputmode="decimal" formControlName="carb_range" placeholder="e.g. 50-100"></ion-input>
                <ion-text slot="end" color="medium">g/day</ion-text>
              </ion-item>
              <small class="text-danger ion-padding-start" *ngIf="form.get('carb_range')?.invalid && form.get('carb_range')?.touched">
                Carb range is required.
              </small>
            </ion-col>
            <ion-col>
              <ion-item>
                <ion-label position="stacked" color="primary">Protein Range</ion-label>
                <ion-input type="text" inputmode="decimal" formControlName="protein_range" placeholder="e.g. 120-150"></ion-input>
                <ion-text slot="end" color="medium">g/day</ion-text>
              </ion-item>
              <small class="text-danger ion-padding-start" *ngIf="form.get('protein_range')?.invalid && form.get('protein_range')?.touched">
                Protein range is required.
              </small>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <div
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        formArrayName="meals"
        class="meal-list"
      >
        <div
          *ngFor="let mealCtrl of mealsArray.controls; let i = index"
          cdkDrag
          [formGroupName]="i"
          class="meal-item"
          [class.meal-item--excluded]="!mealCtrl.get('included')?.value"
        >
          <div *cdkDragPlaceholder class="drag-placeholder"></div>

          <div class="meal-item__header">
            <ion-toggle
              formControlName="included"
              color="success"
              mode="ios"
              class="meal-toggle"
            ></ion-toggle>
            <span class="meal-item__name">{{ mealCtrl.get('display_name')?.value }}</span>
            <ion-icon name="reorder-three-outline" cdkDragHandle class="drag-handle"></ion-icon>
          </div>

          <div class="meal-item__fields" *ngIf="mealCtrl.get('included')?.value">
            <ion-grid>
              <ion-row class="ion-align-items-end">
                <ion-col>
                  <ion-item>
                    <ion-label position="stacked" color="primary">Start</ion-label>
                    <ion-datetime-button [datetime]="'maint-start-' + i" class="time-btn"></ion-datetime-button>
                  </ion-item>
                  <ion-popover [keepContentsMounted]="true">
                    <ng-template>
                      <ion-datetime
                        [id]="'maint-start-' + i"
                        presentation="time"
                        [preferWheel]="true"
                        [value]="toIsoTime(mealCtrl.get('start_time')?.value)"
                        (ionChange)="onTimeChange($event, mealCtrl, 'start_time')"
                      ></ion-datetime>
                    </ng-template>
                  </ion-popover>
                  <small class="text-danger ion-padding-start" *ngIf="!mealCtrl.get('start_time')?.value && mealCtrl.get('start_time')?.touched">
                    Start time is required.
                  </small>
                </ion-col>
                <ion-col>
                  <ion-item>
                    <ion-label position="stacked" color="primary">End</ion-label>
                    <ion-datetime-button [datetime]="'maint-end-' + i" class="time-btn"></ion-datetime-button>
                    <ion-button *ngIf="mealCtrl.get('end_time')?.value" slot="end" fill="clear" color="medium" size="small" (click)="clearField(mealCtrl, 'end_time')">
                      <ion-icon name="close-circle-outline" slot="icon-only"></ion-icon>
                    </ion-button>
                  </ion-item>
                  <ion-popover [keepContentsMounted]="true">
                    <ng-template>
                      <ion-datetime
                        [id]="'maint-end-' + i"
                        presentation="time"
                        [preferWheel]="true"
                        [value]="toIsoTime(mealCtrl.get('end_time')?.value)"
                        (ionChange)="onTimeChange($event, mealCtrl, 'end_time')"
                      ></ion-datetime>
                    </ng-template>
                  </ion-popover>
                </ion-col>
              </ion-row>
              <ion-row *ngIf="PROTEIN_MEALS.has(mealCtrl.get('name')?.value)">
                <ion-col size="6">
                  <ion-item>
                    <ion-label position="stacked" color="primary">Oz Protein</ion-label>
                    <ion-input type="text" inputmode="numeric" formControlName="oz_protein" nxNoScroll></ion-input>
                  </ion-item>
                  <ng-container *ngIf="mealCtrl.get('oz_protein')?.touched">
                    <small class="text-danger ion-padding-start" *ngIf="!mealCtrl.get('oz_protein')?.value">Oz Protein is required.</small>
                    <small class="text-danger ion-padding-start" *ngIf="mealCtrl.get('oz_protein')?.value && !isValidInteger(mealCtrl.get('oz_protein')?.value)">Must be a whole number.</small>
                  </ng-container>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </div>
      </div>
    </form>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" color="success" (click)="save()" [disabled]="isProcessing">
        <ion-spinner *ngIf="isProcessing" name="crescent" slot="start"></ion-spinner>
        {{ isFetchingPreview ? 'Loading Preview...' : 'Save & Preview' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
